import { lazy } from 'react';
import Loadable from '../../components/Loadable';
import { CustomerProvider } from "../../contexts/customerContext/CustomerContext";
import { CustomerDetailProvider } from "../../contexts/customerContext/CustomerDetailContext";

const CustomerFragment = Loadable(lazy(() => import('./views/CustomerFragment')));
const AddCustomerFragment = Loadable(lazy(() => import('./views/AddCustomerFragment')));
const CustomerDetailFragment = Loadable(lazy(() => import('./views/CustomerDetailFragment')));
const ChatWithCustomer = Loadable(lazy(() => import('../chat/ChatWithCustomer')));

const customerRoutes = [
    { path: '/customers', element: <CustomerProvider><CustomerFragment /></CustomerProvider> },
    { path: '/new-customer', element: <CustomerProvider><AddCustomerFragment /></CustomerProvider> },
    { path: '/customer/:id', element: <CustomerDetailProvider><CustomerDetailFragment /></CustomerDetailProvider> },
    { path: '/customer-chat', element: <CustomerProvider><ChatWithCustomer /></CustomerProvider> },
];

export default customerRoutes;
